import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Button,
  Paper,
  Typography,
  Modal,
  TextField,
  IconButton,
  Avatar,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LogoutIcon from "@mui/icons-material/Logout";
import { DataGrid } from "@mui/x-data-grid";
import { showSuccess, showError, showInfo } from "../../../components/ModernSnackbar";
import { useNavigate } from "react-router-dom";
import dataGridStyles from "../gridStyle";
import { userColumns } from "./dashboardColumns";
import { useFetchUser } from "./customHooks/useFetchUser";
import UploadAndValidate from "./UploadExcle";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import AddUserModal from "./AddUserModal";

import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";

import VerifiedIcon from "@mui/icons-material/Verified";
import { handleDelte, handleGenerateLink } from "./helperFn";
import { sendEmail, generateLink, AddSingleUser } from "../../../services/api/fytnServices";

import ActionButton from "./ReusableComponent/ActionButtons";
import DashboardHeader from "./DashboardHeader/DashboardHeader";
import StatsAndFilters from "./DashboardHeader/Filters";
import AlertDialogSlide from "./ConfirmationModal/ConfirmationModal";

import ReportPagePDF from "../../../components/PDF-components/ReportPage";
import { generateReport } from "../../../services/api/fytnServices";
import Cookies from "js-cookie";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: "40%" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const Dashboard = ({ reload, userData }) => {
  console.log('Dashboard: Current user data:', userData);
  console.log('Dashboard: User role:', userData?.userRole);
  
  const [testCount, setTestCount] = useState(0);
  const [reportCount, setReportCount] = useState(0);
  const [testLink, setTestLink] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [searchTerms, setSearchTerms] = useState({});

  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [reFetch, setRefetch] = useState(false);
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [institutionFilter, setInstitutionFilter] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [ids, seIds] = useState([]);
  const [licenses, setLicenses] = useState({ remaining: 0, total: 0 });
  const [selectedIds, setSelectedIds] = useState([]);
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [selectedStudentName, setSelectedStudentName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [emailData, setEmailData] = useState({
    to: "",
    subject: "Your Test Link - Find Your True North",
    message: `Hello,

You have been invited to take the Find Your True North assessment. This assessment will help you discover your interests, personality traits, and values to guide your career and life decisions.

Please click on the link below to start your assessment:

[TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY]

The assessment will take approximately 30-45 minutes to complete. Please ensure you have a quiet environment and can complete it in one sitting.

Best regards,
Find Your True North Team
${userData?.userName || 'Coach'}`
  });
  const [sendingEmail, setSendingEmail] = useState(false);
  const [bulkEmailModalOpen, setBulkEmailModalOpen] = useState(false);
  const [bulkEmailData, setBulkEmailData] = useState({
    subject: "Your Test Link - Find Your True North",
    message: `Hello,

You have been invited to take the Find Your True North assessment. This assessment will help you discover your interests, personality traits, and values to guide your career and life decisions.

Please click on the link below to start your assessment:

[TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY]

The assessment will take approximately 30-45 minutes to complete. Please ensure you have a quiet environment and can complete it in one sitting.

Best regards,
Find Your True North Team
${userData?.userName || 'Coach'}`
  });
  const [sendingBulkEmail, setSendingBulkEmail] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [bulkReportEmailModalOpen, setBulkReportEmailModalOpen] = useState(false);
  const [sendingBulkReportEmail, setSendingBulkReportEmail] = useState(false);
  const [bulkReportEmailData, setBulkReportEmailData] = useState({
    subject: "Your Career Report - Find Your True North",
    message: `Hello,

Your personalized career report is attached to this email.

Best regards,
Find Your True North Team`
  });
  const [reportEmailPreviewOpen, setReportEmailPreviewOpen] = useState(false);
  const [reportEmailData, setReportEmailData] = useState(null);
  const [sendingReportEmail, setSendingReportEmail] = useState(false);

  // Add User Modal State
  const [addUserModalOpen, setAddUserModalOpen] = useState(false);

  const { rows } = useFetchUser(
    reFetch,
    userData.userId,
    reload,
    licenses,
    setLicenses,
    setRefetch
  );
  const [allReport, setAllReport] = useState({});

  const handleGenerateReport = async (user, type, userRow = null) => {
    console.log("USER CONSOLE", user, type);
    try {
      // Find the user row if not provided
      let targetUserRow = userRow;
      if (!targetUserRow) {
        const userId = typeof user === 'object' ? user.id : user;
        targetUserRow = rows.find(row => row.id === userId);
      }
      
      // Check if user is coach and target user type supports reports
      const isCoach = userData.userRole === 'COACH';
      const supportedTypes = ['SCHOOL', 'COLLEGE'];
      if (isCoach && targetUserRow && !supportedTypes.includes(targetUserRow.USER_TYPE)) {
        showError("Reports are only available for SCHOOL and COLLEGE type users");
        return;
      }
      
      setAllReport({});
      
      if (type === "email") {
        // For email, generate report and send via email
        await handleEmailReportFromModal(user, userRow);
        return;
      }
      
      // Store the user data for the modal
      if (userRow) {
        setSelectedUserId(userRow.id);
      } else {
        setSelectedUserId(user);
      }
      
      setDownloadModalOpen(true);
      const data = await generateReport(
        user,
        userData.userId,
        type,
        setDownloadModalOpen
      );
      console.log("RESPONSE", data);
      if (data) {
        setAllReport(data.data);
      } else {
        showError("Unable to get the report");
        setDownloadModalOpen(false);
      }
    } catch (error) {
      console.error("Error generating report:", error.message);
    }
  };

  // Function to generate PDF as blob
  const generatePDFBlob = async (reportData) => {
    const { pdf } = await import('@react-pdf/renderer');
    const StudentPDF = (await import('../../../components/PDF-components/StudentPDF')).default;
    
    const assets = {
      logo2: require('../../../assets/images/logo2.png'),
      upper: require('../../../assets/images/upperDesign.png'),
      lower: require('../../../assets/images/lowerDesign.png'),
      logo: require('../../../assets/images/logo.png'),
      navigation: require('../../../assets/images/navigation.png'),
    };
    
    const blob = await pdf(<StudentPDF data={reportData} assets={assets} />).toBlob();
    return blob;
  };

  // Function to send email with PDF attachment
  const sendReportEmail = async (userEmail, reportData, pdfBlob, subject = "Your Career Report - Find Your True North", message = `Hello,

Your personalized career report is attached to this email.

Best regards,
Find Your True North Team`) => {
    const blobToBase64 = (blob) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };
    
    const pdfBase64 = await blobToBase64(pdfBlob);
    const fileName = `fytn-report-${reportData.name || 'student'}.pdf`;
    
    const emailPayload = {
      to: userEmail,
      subject: subject,
      message: message,
      testLink: null,
      attachments: [{
        filename: fileName,
        content: pdfBase64,
        contentType: 'application/pdf'
      }]
    };
    
    return await sendEmail(userData.userId, emailPayload);
  };

  // Function to handle email report from modal
  const handleEmailReportFromModal = async (userId = null, userRow = null) => {
    try {
      let reportData = allReport;
      let targetUserRow = userRow;
      
      // If called from dropdown menu (with userId), generate report first
      if ((userId && !reportData) || Object.keys(reportData).length === 0) {
        const data = await generateReport(
          userId,
          userData.userId,
          "download",
          null // Don't open modal
        );
        
        if (data && data.data) {
          reportData = data.data;
        } else {
          showError("Unable to generate report");
          return;
        }
      }
      
      // If no userRow provided, find it from rows
      if (!targetUserRow) {
        let currentUserId = userId || selectedUserId;
        
        // If still no user ID, try to get it from report data
        if (!currentUserId && reportData && reportData.student_id) {
          currentUserId = reportData.student_id;
        }
        
        // Try to find user by ID
        targetUserRow = rows.find(user => user.id === currentUserId);
        
        // If not found by ID, try to find by email from report data
        if (!targetUserRow && reportData) {
          // Try different possible email fields
          const possibleEmails = [
            reportData.email,
            reportData.user_email,
            reportData.USER_EMAIL,
            reportData.userEmail
          ].filter(Boolean);
          
          for (const email of possibleEmails) {
            targetUserRow = rows.find(user => user.USER_EMAIL === email);
            if (targetUserRow) {
              break;
            }
          }
        }
      }
      
      if (!targetUserRow) {
        showError("User not found");
        return;
      }
      
      // Check if user is coach and target user type supports reports
      const isCoach = userData.userRole === 'COACH';
      const supportedTypes = ['SCHOOL', 'COLLEGE'];
      if (isCoach && !supportedTypes.includes(targetUserRow.USER_TYPE)) {
        showError("Reports are only available for SCHOOL and COLLEGE type users");
        return;
      }
      
      // Get user email - try multiple sources
      let userEmail = targetUserRow.USER_EMAIL;
      if (!userEmail && reportData && reportData.email) {
        userEmail = reportData.email;
      }
      if (!userEmail && reportData && reportData.user_email) {
        userEmail = reportData.user_email;
      }
      
      if (!userEmail) {
        showError("User email not found");
        return;
      }

      // Store report data and user info for preview
      setReportEmailData({
        to: userEmail,
        subject: "Your Career Report - Find Your True North",
        message: `Hello ${reportData.name || 'there'},

Your personalized career report is attached to this email.

Best regards,
Find Your True North Team`,
        reportData: reportData,
        targetUserRow: targetUserRow
      });
      
      // Open report email preview modal
      setReportEmailPreviewOpen(true);
      
    } catch (error) {
      console.error("Error preparing report email:", error);
      showError("Failed to prepare report email");
    }
  };

  // Function to actually send report email after preview
  const handleSendReportEmailFromPreview = async () => {
    try {
      setSendingReportEmail(true);
      showInfo("Generating report and sending email...");
      
      // Generate PDF as blob
      const pdfBlob = await generatePDFBlob(reportEmailData.reportData);
      
      // Send email with PDF attachment using edited data
      await sendReportEmail(reportEmailData.to, reportEmailData.reportData, pdfBlob, reportEmailData.subject, reportEmailData.message);
      
      showSuccess("Report sent via email successfully!");
      setReportEmailPreviewOpen(false);
      setReportEmailData(null);
    } catch (error) {
      console.error("Error sending report email:", error);
      showError("Failed to send report email");
    } finally {
      setSendingReportEmail(false);
    }
  };

  const handleMenuClick = (event, userId) => {
    setAnchorEl(event.currentTarget);
    setSelectedUserId(userId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedUserId(null);
  };

  // console.log("USER ", allReport)
  const handleOpenConfirmationDialog = (id) => {
    setOpenConfirmationDialog(true);
    // Ensure selectedIds is always an array
    if (Array.isArray(id)) {
      setSelectedIds(id);
    } else if (id !== undefined && id !== null) {
      setSelectedIds([id]);
    } else {
      setSelectedIds([]);
    }
  };
  useEffect(() => {
    const filteredUsers = rows.filter(
      (user) =>
        user.USER_RESPONCE?.value &&
        Object.keys(user.USER_RESPONCE.value).length > 0
    );
    setReportCount(filteredUsers.length);
  }, [rows, reFetch]);

  const handleFileUpload = () => {
    setOpenFileUpload(true);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(testLink);
            showSuccess("Link copied to clipboard!");
    setModalOpen(false);
  };

  const handleSendEmail = async () => {
    if (!emailData.to || !emailData.subject || !emailData.message) {
              showError("Please fill in all email fields");
      return;
    }

    setSendingEmail(true);
    try {
      const targetEmail = emailData.to;
      
      // Find the user in the rows to get their ID and check if they have a test link
      const targetUser = rows.find(user => user.USER_EMAIL === targetEmail);
      
      if (!targetUser) {
        showError("User not found");
        return;
      }

      let userTestLink = targetUser.TOKEN ? 
        `${process.env.REACT_APP_TEST_LINK_BASE_URL || 'https://app.findyourtruenorth.co.in/test-new'}/${targetUser.TOKEN}` : 
        null;

      // If no test link exists, generate one
      if (!userTestLink) {
        try {
          // Generate test link for this user using the API directly
          const linkResponse = await generateLink(targetUser.id, userData.userId);
          
          if (linkResponse?.data?.testLink) {
            userTestLink = linkResponse.data.testLink;
          } else {
            showError("Failed to generate test link");
            return;
          }
        } catch (error) {
          console.error("Error generating test link:", error);
                      showError("Failed to generate test link");
          return;
        }
      }

      // Replace the placeholder with the actual test link
      const messageWithLink = emailData.message.replace('[TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY]', userTestLink);
      
      const emailPayload = {
        to: emailData.to,
        subject: emailData.subject,
        message: messageWithLink,
        testLink: userTestLink
      };

      const response = await sendEmail(userData.userId, emailPayload);
      
      if (response.status === 'success') {
        showSuccess("Email sent successfully!");
        setEmailModalOpen(false);
        setEmailData({
          to: "",
          subject: "Your Test Link - Find Your True North",
          message: `Hello,

You have been invited to take the Find Your True North assessment. This assessment will help you discover your interests, personality traits, and values to guide your career and life decisions.

Please click on the link below to start your assessment:

[TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY]

The assessment will take approximately 30-45 minutes to complete. Please ensure you have a quiet environment and can complete it in one sitting.

Best regards,
Find Your True North Team
${userData?.userName || 'Coach'}`
        });
      } else {
        showError(response.message || "Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
              showError("Error sending email. Please try again.");
    } finally {
      setSendingEmail(false);
    }
  };

  // Bulk email functionality
  const handleBulkEmail = () => {
    // Get selected users who don't have responses yet
    let eligibleUsers = rows.filter(user => 
      selectedIds.includes(user.id) && user.USER_RESPONCE == null
    );
    
    if (eligibleUsers.length === 0) {
      showError("No eligible users selected. Please select users who haven't completed the assessment.");
      return;
    }
    
    setSelectedEmails(eligibleUsers.map(user => ({
      id: user.id,
      email: user.USER_EMAIL,
      name: user.USER_NAME
    })));
    setBulkEmailModalOpen(true);
  };

  // Bulk report email functionality
  const handleBulkReportEmail = () => {
    // Check if user is coach
    const isCoach = userData.userRole === 'COACH';
    
    // Get selected users who have completed the assessment
    let eligibleUsers = rows.filter(user => 
      selectedIds.includes(user.id) && user.USER_RESPONCE != null
    );
    
    // If coach, filter to only supported user types (SCHOOL, COLLEGE)
    if (isCoach) {
      const supportedTypes = ['SCHOOL', 'COLLEGE'];
      eligibleUsers = eligibleUsers.filter(user => supportedTypes.includes(user.USER_TYPE));
      if (eligibleUsers.length === 0) {
        showError("No eligible users selected. Reports can only be sent to SCHOOL and COLLEGE type users who have completed the assessment.");
        return;
      }
    }
    
    if (eligibleUsers.length === 0) {
      showError("No eligible users selected. Please select users who have completed the assessment.");
      return;
    }
    
    setSelectedEmails(eligibleUsers.map(user => ({
      id: user.id,
      email: user.USER_EMAIL,
      name: user.USER_NAME
    })));
    setBulkReportEmailModalOpen(true);
  };

  const handleSendBulkEmail = async () => {
    if (!bulkEmailData.subject.trim() || !bulkEmailData.message.trim()) {
      showError("Please fill in all required fields");
      return;
    }

    setSendingBulkEmail(true);
    try {
      const emailPromises = selectedIds.map(userId => {
        const user = rows.find(row => row.id === userId);
        if (!user) return Promise.resolve();

        const emailPayload = {
          to: user.USER_EMAIL,
          subject: bulkEmailData.subject,
          message: bulkEmailData.message.replace('[TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY]', user.testLink || 'Test link not available')
        };

        return sendEmail(userData.userId, emailPayload);
      });

      await Promise.all(emailPromises);
      showSuccess("Bulk emails sent successfully!");
      setBulkEmailModalOpen(false);
      setSelectedIds([]);
    } catch (error) {
      console.error("Error sending bulk emails:", error);
      showError("Failed to send bulk emails");
    } finally {
      setSendingBulkEmail(false);
    }
  };

  const handleSendBulkReportEmail = async () => {
    // Check if user is coach
    const isCoach = userData.userRole === 'COACH';

    setSendingBulkReportEmail(true);
    try {
      showInfo("Generating reports and sending emails...");
      
      const emailPromises = selectedIds.map(async (userId) => {
        const user = rows.find(row => row.id === userId);
        if (!user || !user.USER_RESPONCE) return Promise.resolve();

        // If coach, only send to supported user types
        const supportedTypes = ['SCHOOL', 'COLLEGE'];
        if (isCoach && !supportedTypes.includes(user.USER_TYPE)) {
          console.log(`Skipping unsupported user type for report: ${user.USER_EMAIL}`);
          return Promise.resolve();
        }

        try {
          // Generate report for this user
          const reportData = await generateReport(
            userId,
            userData.userId,
            "download",
            null // Don't open modal
          );

          if (!reportData || !reportData.data) {
            console.error(`Failed to generate report for user ${userId}`);
            return Promise.resolve();
          }

          // Generate PDF blob
          const pdfBlob = await generatePDFBlob(reportData.data);
          
          // Send email with PDF attachment using custom subject and message
          await sendReportEmail(user.USER_EMAIL, reportData.data, pdfBlob, bulkReportEmailData.subject, bulkReportEmailData.message);
          
          return { success: true, userId, email: user.USER_EMAIL };
        } catch (error) {
          console.error(`Error processing user ${userId}:`, error);
          return { success: false, userId, email: user.USER_EMAIL, error: error.message };
        }
      });

      const results = await Promise.all(emailPromises);
      const successful = results.filter(r => r.success);
      const failed = results.filter(r => !r.success);

      if (successful.length > 0) {
        showSuccess(`Successfully sent ${successful.length} report emails!`);
      }
      if (failed.length > 0) {
        showError(`Failed to send ${failed.length} report emails. Check console for details.`);
      }

      setBulkReportEmailModalOpen(false);
      setSelectedIds([]);
    } catch (error) {
      console.error("Error sending bulk report emails:", error);
      showError("Failed to send bulk report emails");
    } finally {
      setSendingBulkReportEmail(false);
    }
  };

  // Add User Modal Handlers
  const handleAddUser = () => {
    setAddUserModalOpen(true);
  };

  const handleAddUserSubmit = async (formData) => {
    console.log('Dashboard: handleAddUserSubmit called with formData:', formData);
    console.log('Dashboard: userData.userId (coach ID):', userData.userId);
    try {
      // Prepare the API payload based on the actual user_master table structure
      const apiPayload = {
        USER_NAME: formData.name,
        USER_AGE: formData.age,
        USER_EMAIL: formData.email,
        USER_PHONE_NO: formData.phone,
        USER_TYPE: formData.userType,
        USER_AUTH_MASTER_ID: userData.userId, // Add the coach's ID for mapping
      };

      // Add user type specific fields
      if (formData.userType === 'COLLEGE') {
        apiPayload.USER_COURSE = formData.course;
        apiPayload.INSTITUTION_NAME = formData.college;
      } else if (formData.userType === 'SCHOOL') {
        apiPayload.USER_GRADE = `${formData.grade}-${formData.section}`;
        apiPayload.INSTITUTION_NAME = formData.school;
      } else if (formData.userType === 'PROFESSIONAL') {
        apiPayload.COMPANY_NAME = formData.company;
        apiPayload.USER_COMPANY_ROLE = formData.role;
        apiPayload.USER_COMPANY_HIGHER_EDUCATION = formData.education;
      }

      console.log('Dashboard: Prepared API payload:', apiPayload);
      console.log('Dashboard: USER_AUTH_MASTER_ID in payload:', apiPayload.USER_AUTH_MASTER_ID);

      // Make the API call
      console.log('Dashboard: Making API call to AddSingleUser');
      const response = await AddSingleUser(apiPayload);
      console.log('Dashboard: API response received:', response);
      
      // Check the response structure from backend
      if (response && response.data && response.data.status === 'success') {
        console.log('Dashboard: Success response, showing success message');
        showSuccess("User added successfully!");
        setRefetch(prev => !prev); // Refresh the user list
      } else if (response && response.data && response.data.status === 'error') {
        // Handle backend error response
        console.log('Dashboard: Error response from backend:', response.data.message);
        showError(response.data.message || "Failed to add user. Please try again.");
      } else {
        console.log('Dashboard: Unexpected response structure:', response);
        showError("Failed to add user. Please try again.");
      }
    } catch (error) {
      console.error("Dashboard: Error adding user:", error);
      
      // Handle different error response structures
      if (error.response && error.response.data) {
        if (error.response.data.status === 'error') {
          showError(error.response.data.message || "Failed to add user. Please try again.");
        } else {
          showError(error.response.data.message || "Failed to add user. Please try again.");
        }
      } else {
        showError("Failed to add user. Please try again.");
      }
    }
  };

  const handleAddUserClose = () => {
    setAddUserModalOpen(false);
  };

  console.log("selectedIds", selectedIds);
  
  // Helper functions to check if selected users are valid for each action
  const getValidUsersForDelete = () => {
    return selectedIds.filter(id => {
      const row = filteredRows.find(r => r.id === id);
      return row && (!row.USER_RESPONCE || !row.USER_RESPONCE.value);
    });
  };

  const getValidUsersForBulkEmail = () => {
    return selectedIds.filter(id => {
      const row = filteredRows.find(r => r.id === id);
      return row && !row.USER_RESPONCE;
    });
  };

  const getValidUsersForBulkReports = () => {
    const isCoach = userData.userRole === 'COACH';
    return selectedIds.filter(id => {
      const row = filteredRows.find(r => r.id === id);
      // Must have completed assessment
      if (!row || !row.USER_RESPONCE) return false;
      // If coach, must be a supported user type
      const supportedTypes = ['SCHOOL', 'COLLEGE'];
      if (isCoach && !supportedTypes.includes(row.USER_TYPE)) return false;
      return true;
    });
  };

  const filteredRows = useMemo(() => {
    return rows.filter((user) => {
      const matchesUserType = userTypeFilter
        ? user.USER_TYPE?.toLowerCase() === userTypeFilter.toLowerCase()
        : true;

      const matchesInstitution = institutionFilter
        ? user.INSTITUTION_NAME === institutionFilter
        : true;

      const matchesSearchTerms = Object.entries(searchTerms).every(
        ([field, value]) =>
          value
            ? String(user[field] ?? "")
                .toLowerCase()
                .includes(value.toLowerCase())
            : true
      );

      return matchesUserType && matchesInstitution && matchesSearchTerms;
    });
  }, [rows, userTypeFilter, institutionFilter, searchTerms, reFetch]);
  const columns = userColumns(
    setModalOpen,
    setTestLink,
    searchTerms,
    setSearchTerms,
    licenses,
    handleOpenConfirmationDialog,
    selectedIds,
    userData.userId,
    handleGenerateReport,
    anchorEl,
    selectedUserId,
    handleMenuClick,
    handleMenuClose,
    setEmailModalOpen,
    setEmailData,
    userData.userName,
    userData.userRole // Pass userRole to check if user is coach
  );

  const isMobile = useMemo(() => {
    return window.innerWidth < 600; // Adjust breakpoint as needed
  }, []);

  return (
    <>
      {/* Drawer for Mobile */}

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{ display: { xs: "block", md: "none", sm: "none" } }}
      >
        <Box sx={{ width: 250, p: 2 }}>
          {/* Dashboard Title */}
          <Typography variant="h6" fontWeight="bold" mb={3}>
            Dashboard
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              gap: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Avatar alt={userData.userName} />
              <Typography variant="subtitle1" fontWeight="500">
                {userData.userName}
              </Typography>
            </Box>
            <Button
              fullWidth
              variant="contained"
              onClick={() => {
                setDrawerOpen(false);
                handleFileUpload();
              }}
              sx={{ mb: 2 }}
            >
              Upload Data
            </Button>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor: "#e3f2fd",
                px: 2,
                py: 1,
                borderRadius: 2,
                boxShadow: 1,
                mb: 2,
              }}
            >
              <VerifiedIcon color="primary" />
              <Typography variant="body2" fontWeight="600" color="primary.dark" sx={{ fontSize: "12px" }}>
                Total License Remaining: {licenses.remaining}/{licenses?.total}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Drawer>

      <Box sx={{ width: "100%" }}>
        {/* Main Content Area */}
        <Box sx={{ width: "100%" }}>
          <>
            {/* Top Toolbar */}
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setDrawerOpen(true)}
              sx={{ display: { xs: "none", md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <DashboardHeader
              userData={userData}
              licenses={licenses}
              reportCount={reportCount}
              rows={rows}
              handleFileUpload={handleFileUpload}
            />
            <StatsAndFilters
              reportCount={reportCount}
              userTypeFilter={userTypeFilter}
              institutionFilter={institutionFilter}
              setUserTypeFilter={setUserTypeFilter}
              setInstitutionFilter={setInstitutionFilter}
              rows={rows}
            />

            {/* DataGrid */}
            <Box
              sx={{
                mt: 1,
                display: "flex",
                gap: 1,
                justifyContent: "flex-end",
                mb: 0.5,
              }}
            >
              <Button
                variant="contained"
                onClick={handleFileUpload}
                sx={{ display: "inline-flex" }}
              >
                Upload Data
              </Button>

              <Button
                variant="contained"
                onClick={handleAddUser}
                sx={{ display: "inline-flex" }}
              >
                Add User
              </Button>

              <ActionButton
                label="Generate Link"
                color="secondary"
                selectedIds={selectedIds}
                filteredRows={filteredRows}
                validateRow={(row) => {
                  return row?.TOKEN !== null &&
                    (!row.USER_RESPONCE || !row.USER_RESPONCE.value);
                }}
                disabled={true || selectedIds.length < 1}
                onAction={handleGenerateLink}
                additionalArgs={[setModalOpen, setTestLink, userData.userId]}
              />
              <ActionButton
                label="Delete All"
                color="warning"
                selectedIds={selectedIds}
                filteredRows={filteredRows}
                disabled={getValidUsersForDelete().length < 2}
                validateRow={(row) =>
                  row?.TOKEN !== null &&
                  (!row.USER_RESPONCE || !row.USER_RESPONCE.value)
                }
                onAction={() => setOpenConfirmationDialog(true)}
                additionalArgs={[setModalOpen, setTestLink, userData.userId]}
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  "&:hover": { backgroundColor: "#b71c1c" },
                }}
              />
              <ActionButton
                label="Send Bulk Email"
                color="primary"
                selectedIds={selectedIds}
                filteredRows={filteredRows}
                disabled={getValidUsersForBulkEmail().length < 1}
                validateRow={(row) => !row.USER_RESPONCE}
                onAction={handleBulkEmail}
                sx={{
                  backgroundColor: "#1976d2",
                  color: "white",
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              />
              <ActionButton
                label="Send Bulk Reports"
                color="secondary"
                selectedIds={selectedIds}
                filteredRows={filteredRows}
                disabled={getValidUsersForBulkReports().length < 1}
                validateRow={(row) => {
                  // Must have completed assessment
                  if (!row.USER_RESPONCE) return false;
                  // If coach, must be a supported user type
                  if (userData.userRole === 'COACH' && !['SCHOOL', 'COLLEGE'].includes(row.USER_TYPE)) return false;
                  return true;
                }}
                onAction={handleBulkReportEmail}
                sx={{
                  backgroundColor: "#9c27b0",
                  color: "white",
                  "&:hover": { backgroundColor: "#7b1fa2" },
                }}
              />
            </Box>

            <Box sx={{ width: "100%", overflowX: "auto", height: 490 }}>
              <DataGrid
                rows={filteredRows}
                columns={columns}
                pageSize={15}
                disableRowSelectionOnClick
                checkboxSelection={licenses.remaining > 0}
                onRowSelectionModelChange={(newSelection) => {
                  if (licenses.remaining > 0) {
                    const validSelection = newSelection.filter((id) => {
                      const selectedRow = filteredRows.find(
                        (row) => row.id === id
                      );
                      return selectedRow; // Allow selection of all users
                    });

                    setSelectedIds(validSelection);
                  }
                }}
                rowSelectionModel={selectedIds}
                getRowId={(row) => row.id}
                sx={dataGridStyles}
              />
            </Box>

            {/* Test Link Modal */}
            <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
              <Box sx={modalStyle}>
                <Typography variant="h6" mb={2}>
                  Test Link
                </Typography>
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <TextField
                    fullWidth
                    value={testLink}
                    InputProps={{ readOnly: true }}
                    placeholder="Test link will appear here..."
                  />
                  <IconButton 
                    onClick={handleCopy} 
                    color="primary"
                    title="Copy to clipboard"
                    sx={{ 
                      bgcolor: 'primary.main', 
                      color: 'white',
                      '&:hover': { bgcolor: 'primary.dark' }
                    }}
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </Box>
              </Box>
            </Modal>

            {/* Email Modal */}
            <Modal 
              open={emailModalOpen} 
              onClose={() => {}} // Disable closing on outside click
              disableEscapeKeyDown={true} // Disable ESC key closing
            >
              <Box sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '95%', sm: '90%', md: '85%', lg: 600 },
                maxWidth: { xs: '95vw', sm: '90vw', md: '85vw', lg: 600 },
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: { xs: 2, sm: 3, md: 4 },
                borderRadius: 2,
                maxHeight: { xs: '95vh', sm: '90vh', md: '80vh' },
                height: { xs: 'auto', sm: 'auto', md: 'auto' },
                overflow: 'auto',
                mx: { xs: 1, sm: 2, md: 3 },
                // Fix for iPad scrolling and centering
                WebkitOverflowScrolling: 'touch',
                msOverflowStyle: 'scrollbar',
                // Ensure modal is always centered
                zIndex: 1300,
                // Fix positioning for tablet landscape
                '@media (min-width: 820px) and (max-width: 1180px)': {
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '85%',
                  maxWidth: '85vw'
                },
                '&::-webkit-scrollbar': {
                  width: '8px',
                  height: '8px'
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                  borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#c1c1c1',
                  borderRadius: '4px',
                  '&:hover': {
                    background: '#a8a8a8'
                  }
                }
              }}>
                <Typography variant={isMobile ? "h6" : "h5"} mb={3}>
                  Send Test Link via Email
                </Typography>
                
                {/* Email Form */}
                <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }} mb={3}>
                  <TextField
                    label="To Email"
                    value={emailData.to}
                    onChange={(e) => setEmailData({...emailData, to: e.target.value})}
                    fullWidth
                    required
                    size={isMobile ? "small" : "medium"}
                  />
                  <TextField
                    label="Subject"
                    value={emailData.subject}
                    onChange={(e) => setEmailData({...emailData, subject: e.target.value})}
                    fullWidth
                    required
                    size={isMobile ? "small" : "medium"}
                  />
                  <TextField
                    label="Message"
                    value={emailData.message}
                    onChange={(e) => setEmailData({...emailData, message: e.target.value})}
                    multiline
                    rows={{ xs: 4, sm: 5, md: 6 }}
                    fullWidth
                    required
                    placeholder="Enter your message here. The test link will be automatically included."
                    size={isMobile ? "small" : "medium"}
                  />
                </Box>

                {/* Email Preview */}
                <Box mb={3} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: { xs: 1.5, sm: 2 }, bgcolor: '#fafafa' }}>
                  <Typography variant="subtitle2" color="text.secondary" mb={1}>
                    Email Preview:
                  </Typography>
                  <Box sx={{ 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    p: { xs: 1.5, sm: 2 }, 
                    bgcolor: 'white'
                  }}>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>To:</strong> {emailData.to || 'No recipient specified'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Subject:</strong> {emailData.subject || 'No subject'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Message:</strong>
                    </Typography>
                    <Box sx={{ 
                      whiteSpace: 'pre-wrap', 
                      fontFamily: 'inherit',
                      fontSize: { xs: '0.8rem', sm: '0.875rem' },
                      color: '#666',
                      maxHeight: { xs: '120px', sm: '150px', md: '200px' },
                      overflow: 'auto',
                      // Fix for iPad scrolling
                      WebkitOverflowScrolling: 'touch',
                      msOverflowStyle: 'scrollbar'
                    }}>
                      {emailData.message || 'No message content'}
                    </Box>
                    <Typography variant="body2" color="text.secondary" mt={1}>
                      <strong>Test Link:</strong> 🔗 Will be automatically included
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" gap={{ xs: 1, sm: 2 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                  <Button
                    variant="outlined"
                    onClick={() => setEmailModalOpen(false)}
                    fullWidth
                    size={isMobile ? "small" : "medium"}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSendEmail}
                    disabled={sendingEmail}
                    fullWidth
                    size={isMobile ? "small" : "medium"}
                  >
                    {sendingEmail ? "Sending..." : "Send Email"}
                  </Button>
                </Box>
              </Box>
            </Modal>

            {/* Bulk Email Modal */}
            <Modal 
              open={bulkEmailModalOpen} 
              onClose={() => {}} // Disable closing on outside click
              disableEscapeKeyDown={true} // Disable ESC key closing
            >
              <Box sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '95%', sm: '90%', md: '85%', lg: 700 },
                maxWidth: { xs: '95vw', sm: '90vw', md: '85vw', lg: 700 },
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: { xs: 2, sm: 3, md: 4 },
                borderRadius: 2,
                maxHeight: { xs: '95vh', sm: '90vh', md: '80vh' },
                height: { xs: 'auto', sm: 'auto', md: 'auto' },
                overflow: 'auto',
                mx: { xs: 1, sm: 2, md: 3 },
                // Fix for iPad scrolling and centering
                WebkitOverflowScrolling: 'touch',
                msOverflowStyle: 'scrollbar',
                // Ensure modal is always centered
                zIndex: 1300,
                // Fix positioning for tablet landscape
                '@media (min-width: 820px) and (max-width: 1180px)': {
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '85%',
                  maxWidth: '85vw'
                },
                '&::-webkit-scrollbar': {
                  width: '8px',
                  height: '8px'
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                  borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#c1c1c1',
                  borderRadius: '4px',
                  '&:hover': {
                    background: '#a8a8a8'
                  }
                }
              }}>
                <Typography variant={isMobile ? "h6" : "h5"} mb={3}>
                  Send Test Links to Multiple Recipients ({selectedEmails.length} selected)
                </Typography>
                
                {/* Recipients List */}
                <Box mb={3}>
                  <Typography variant="subtitle2" mb={1} color="text.secondary">
                    Recipients:
                  </Typography>
                  <Box sx={{ 
                    maxHeight: { xs: 100, sm: 120, md: 150 }, 
                    overflow: 'auto', 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    p: { xs: 0.5, sm: 1 },
                    // Fix for iPad scrolling
                    WebkitOverflowScrolling: 'touch',
                    msOverflowStyle: 'scrollbar'
                  }}>
                    {selectedEmails.map((recipient, index) => (
                      <Box key={recipient.id} sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        py: { xs: 0.25, sm: 0.5 },
                        px: { xs: 0.5, sm: 1 }
                      }}>
                        <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>
                          {recipient.name} ({recipient.email})
                        </Typography>
                        <IconButton
                          size={isMobile ? "small" : "medium"}
                          onClick={() => setSelectedEmails(selectedEmails.filter((_, i) => i !== index))}
                        >
                          <CloseIcon fontSize={isMobile ? "small" : "medium"} />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Email Content Editing */}
                <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }} mb={3}>
                  <TextField
                    label="Subject"
                    value={bulkEmailData.subject}
                    onChange={(e) => setBulkEmailData({...bulkEmailData, subject: e.target.value})}
                    fullWidth
                    required
                    placeholder="Enter email subject"
                    size={isMobile ? "small" : "medium"}
                  />
                  <TextField
                    label="Message"
                    value={bulkEmailData.message}
                    onChange={(e) => setBulkEmailData({...bulkEmailData, message: e.target.value})}
                    multiline
                    rows={{ xs: 4, sm: 5, md: 6 }}
                    fullWidth
                    required
                    placeholder="Enter your message here. The test link will be automatically included for each recipient."
                    helperText="Use [TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY] as placeholder for the test link"
                    size={isMobile ? "small" : "medium"}
                  />
                </Box>

                {/* Enhanced Email Preview */}
                <Box mb={3} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: { xs: 1.5, sm: 2 }, bgcolor: '#fafafa' }}>
                  <Typography variant="subtitle2" color="text.secondary" mb={1}>
                    Email Preview:
                  </Typography>
                  <Box sx={{ 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    p: { xs: 1.5, sm: 2 }, 
                    bgcolor: 'white'
                  }}>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Subject:</strong> {bulkEmailData.subject || 'No subject'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Recipients:</strong> {selectedEmails.length} users
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Message:</strong>
                    </Typography>
                    <Box sx={{ 
                      whiteSpace: 'pre-wrap', 
                      fontFamily: 'inherit',
                      fontSize: { xs: '0.8rem', sm: '0.875rem' },
                      color: '#666',
                      maxHeight: { xs: '100px', sm: '120px', md: '150px' },
                      overflow: 'auto',
                      // Fix for iPad scrolling
                      WebkitOverflowScrolling: 'touch',
                      msOverflowStyle: 'scrollbar'
                    }}>
                      {bulkEmailData.message || 'No message content'}
                    </Box>
                    <Typography variant="body2" color="text.secondary" mt={1}>
                      <strong>Test Link:</strong> 🔗 Will be automatically included for each recipient
                    </Typography>
                    
                    {/* Sample Recipient Preview */}
                    {selectedEmails.length > 0 && (
                      <Box mt={2} sx={{ borderTop: '1px solid #e0e0e0', pt: 2 }}>
                        <Typography variant="body2" color="text.secondary" mb={1}>
                          <strong>Sample for first recipient ({selectedEmails[0].name}):</strong>
                        </Typography>
                        <Box sx={{ 
                          bgcolor: '#f5f5f5', 
                          p: { xs: 0.5, sm: 1 }, 
                          borderRadius: 1, 
                          fontSize: { xs: '0.7rem', sm: '0.8rem' },
                          fontFamily: 'monospace'
                        }}>
                          To: {selectedEmails[0].email}<br/>
                          Subject: {bulkEmailData.subject || 'No subject'}<br/>
                          Message: {bulkEmailData.message?.replace('[TEST_LINK_WILL_BE_ADDED_AUTOMATICALLY]', 'https://example.com/test-link-123') || 'No message'}
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>

                <Box display="flex" gap={{ xs: 1, sm: 2 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                  <Button
                    variant="outlined"
                    onClick={() => setBulkEmailModalOpen(false)}
                    fullWidth
                    size={isMobile ? "small" : "medium"}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSendBulkEmail}
                    disabled={sendingBulkEmail || selectedEmails.length === 0}
                    fullWidth
                    size={isMobile ? "small" : "medium"}
                  >
                    {sendingBulkEmail ? `Sending... (${selectedEmails.length} emails)` : `Send to ${selectedEmails.length} Recipients`}
                  </Button>
                </Box>
              </Box>
            </Modal>

            <Modal
              open={openFileUpload}
              onClose={(event, reason) => {
                // Prevent closing on backdrop click or ESC
                if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                  setOpenFileUpload(false);
                }
              }}
            >
              <Box
                sx={{
                  ...modalStyle,
                  position: "relative",
                  width: { xs: "95%", sm: "90%", md: "60%" },
                  height: { xs: "auto", sm: "auto", md: "auto" },
                  maxHeight: { xs: "none", md: "80vh" }, // disable max height on small screens
                  overflow: "auto", // prevent scrollbars
                  p: { xs: 2, sm: 3, md: 4 },
                  bgcolor: "background.paper",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                {/* Close Icon Button */}
                <IconButton
                  onClick={() => setOpenFileUpload(false)}
                  sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
                >
                  <CloseIcon />
                </IconButton>

                <UploadAndValidate
                  onClose={() => setOpenFileUpload(false)}
                  setOpenFileUpload={setOpenFileUpload}
                  setRefetch={setRefetch}
                  userId={userData.userId}
                />
              </Box>
            </Modal>

            {/* Bulk Report Email Modal */}
            <Modal 
              open={bulkReportEmailModalOpen} 
              onClose={() => {}} // Disable closing on outside click
              disableEscapeKeyDown={true} // Disable ESC key closing
            >
              <Box
                sx={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: { xs: "95%", sm: "90%", md: "85%", lg: 600 },
                  maxWidth: { xs: "95vw", sm: "90vw", md: "85vw", lg: 600 },
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: { xs: 2, sm: 3, md: 4 },
                  borderRadius: 2,
                  maxHeight: { xs: "95vh", sm: "90vh", md: "80vh" },
                  height: { xs: "auto", sm: "auto", md: "auto" },
                  overflow: "auto",
                  mx: { xs: 1, sm: 2, md: 3 },
                  // Fix for iPad scrolling and centering
                  WebkitOverflowScrolling: 'touch',
                  msOverflowStyle: 'scrollbar',
                  // Ensure modal is always centered
                  zIndex: 1300,
                  // Fix positioning for tablet landscape
                  '@media (min-width: 820px) and (max-width: 1180px)': {
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '85%',
                    maxWidth: '85vw'
                  }
                }}
              >
                <Typography variant={isMobile ? "h6" : "h5"} component="h2" gutterBottom>
                  Send Bulk Report Emails
                </Typography>

                <Typography variant="body2" color="text.secondary" mb={3}>
                  This will generate and send PDF reports to {selectedEmails.length} selected users who have completed their assessments.
                </Typography>

                {/* Recipients List */}
                <Box mb={3}>
                  <Typography variant="subtitle2" mb={1} color="text.secondary">
                    Recipients:
                  </Typography>
                  <Box sx={{ 
                    maxHeight: { xs: 100, sm: 120, md: 150 }, 
                    overflow: 'auto', 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    p: { xs: 0.5, sm: 1 } 
                  }}>
                    {selectedEmails.map((recipient, index) => (
                      <Box key={recipient.id} sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        py: { xs: 0.25, sm: 0.5 },
                        px: { xs: 0.5, sm: 1 }
                      }}>
                        <Typography variant="body2" sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>
                          {recipient.name} ({recipient.email})
                        </Typography>
                        <IconButton
                          size={isMobile ? "small" : "medium"}
                          onClick={() => setSelectedEmails(selectedEmails.filter((_, i) => i !== index))}
                        >
                          <CloseIcon fontSize={isMobile ? "small" : "medium"} />
                        </IconButton>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Email Content Editing */}
                <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }} mb={3}>
                  <TextField
                    label="Subject"
                    value={bulkReportEmailData.subject || "Your Career Report - Find Your True North"}
                    onChange={(e) => setBulkReportEmailData({...bulkReportEmailData, subject: e.target.value})}
                    fullWidth
                    required
                    placeholder="Enter email subject"
                    size={isMobile ? "small" : "medium"}
                  />
                  <TextField
                    label="Message"
                    value={bulkReportEmailData.message || `Hello,

Your personalized career report is attached to this email.

Best regards,
Find Your True North Team`}
                    onChange={(e) => setBulkReportEmailData({...bulkReportEmailData, message: e.target.value})}
                    multiline
                    rows={{ xs: 4, sm: 5, md: 6 }}
                    fullWidth
                    required
                    placeholder="Enter your message here. The report will be automatically attached."
                    helperText="Each recipient will receive their personalized report as a PDF attachment."
                    size={isMobile ? "small" : "medium"}
                  />
                </Box>

                {/* Email Preview */}
                <Box mb={3} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: { xs: 1.5, sm: 2 }, bgcolor: '#fafafa' }}>
                  <Typography variant="subtitle2" color="text.secondary" mb={1}>
                    Email Preview:
                  </Typography>
                  <Box sx={{ 
                    border: '1px solid #e0e0e0', 
                    borderRadius: 1, 
                    p: { xs: 1.5, sm: 2 }, 
                    bgcolor: 'white'
                  }}>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Subject:</strong> {bulkReportEmailData.subject || "Your Career Report - Find Your True North"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Recipients:</strong> {selectedEmails.length} users
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={1}>
                      <strong>Message:</strong>
                    </Typography>
                    <Box sx={{ 
                      whiteSpace: 'pre-wrap', 
                      fontFamily: 'inherit',
                      fontSize: { xs: '0.8rem', sm: '0.875rem' },
                      color: '#666',
                      maxHeight: { xs: '100px', sm: '120px', md: '150px' },
                      overflow: 'auto'
                    }}>
                      {bulkReportEmailData.message || `Hello,

Your personalized career report is attached to this email.

Best regards,
Find Your True North Team`}
                    </Box>
                    <Typography variant="body2" color="text.secondary" mt={1}>
                      <strong>Attachment:</strong> 📎 Personalized PDF report for each recipient
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex" gap={{ xs: 1, sm: 2 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                  <Button
                    variant="outlined"
                    onClick={() => setBulkReportEmailModalOpen(false)}
                    fullWidth
                    size={isMobile ? "small" : "medium"}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSendBulkReportEmail}
                    disabled={sendingBulkReportEmail || selectedEmails.length === 0}
                    fullWidth
                    size={isMobile ? "small" : "medium"}
                    sx={{
                      bgcolor: '#9c27b0',
                      '&:hover': { bgcolor: '#7b1fa2' }
                    }}
                  >
                    {sendingBulkReportEmail ? `Sending... (${selectedEmails.length} reports)` : `Send ${selectedEmails.length} Report Emails`}
                  </Button>
                </Box>
              </Box>
            </Modal>

            {/* Report Email Preview Modal */}
            <Modal 
              open={reportEmailPreviewOpen} 
              onClose={() => {}} // Disable closing on outside click
              disableEscapeKeyDown={true} // Disable ESC key closing
            >
              <Box sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '95%', sm: '90%', md: '85%', lg: 700 },
                maxWidth: { xs: '95vw', sm: '90vw', md: '85vw', lg: 700 },
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: { xs: 2, sm: 3, md: 4 },
                borderRadius: 2,
                maxHeight: { xs: '90vh', sm: '85vh', md: '75vh' },
                height: { xs: 'auto', sm: 'auto', md: 'auto' },
                overflow: 'auto',
                mx: { xs: 1, sm: 2, md: 3 },
                // Fix for iPad scrolling and centering
                WebkitOverflowScrolling: 'touch',
                msOverflowStyle: 'scrollbar',
                // Ensure modal is always centered
                zIndex: 1300,
                // Fix positioning for tablet landscape
                '@media (min-width: 820px) and (max-width: 1180px)': {
                  position: 'fixed',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '85%',
                  maxWidth: '85vw'
                },
                '&::-webkit-scrollbar': {
                  width: '8px',
                  height: '8px'
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                  borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#c1c1c1',
                  borderRadius: '4px',
                  '&:hover': {
                    background: '#a8a8a8'
                  }
                }
              }}>
                <Typography variant={isMobile ? "h6" : "h5"} mb={3}>
                  Preview & Edit Report Email
                </Typography>
                
                {reportEmailData && (
                  <>
                    {/* Email Editing Form */}
                    <Box display="flex" flexDirection="column" gap={{ xs: 1.5, sm: 2 }} mb={3}>
                      <TextField
                        label="To Email"
                        value={reportEmailData.to}
                        onChange={(e) => setReportEmailData({...reportEmailData, to: e.target.value})}
                        fullWidth
                        required
                        placeholder="Enter recipient email"
                        size={isMobile ? "small" : "medium"}
                      />
                      <TextField
                        label="Subject"
                        value={reportEmailData.subject}
                        onChange={(e) => setReportEmailData({...reportEmailData, subject: e.target.value})}
                        fullWidth
                        required
                        placeholder="Enter email subject"
                        size={isMobile ? "small" : "medium"}
                      />
                      <TextField
                        label="Message"
                        value={reportEmailData.message}
                        onChange={(e) => setReportEmailData({...reportEmailData, message: e.target.value})}
                        multiline
                        rows={{ xs: 3, sm: 4, md: 5 }}
                        fullWidth
                        required
                        placeholder="Enter your message here"
                        helperText="You can customize the message for this specific recipient"
                        size={isMobile ? "small" : "medium"}
                      />
                    </Box>

                    {/* Email Preview */}
                    <Box mb={3} sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: { xs: 1.5, sm: 2 }, bgcolor: '#fafafa' }}>
                      <Typography variant="subtitle2" color="text.secondary" mb={1}>
                        Email Preview:
                      </Typography>
                      <Box sx={{ 
                        border: '1px solid #e0e0e0', 
                        borderRadius: 1, 
                        p: { xs: 1.5, sm: 2 }, 
                        bgcolor: 'white'
                      }}>
                        <Typography variant="body2" color="text.secondary" mb={1}>
                          <strong>To:</strong> {reportEmailData.to || 'No recipient specified'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mb={1}>
                          <strong>Subject:</strong> {reportEmailData.subject || 'No subject'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" mb={1}>
                          <strong>Message:</strong>
                        </Typography>
                        <Box sx={{ 
                          whiteSpace: 'pre-wrap', 
                          fontFamily: 'inherit',
                          fontSize: { xs: '0.8rem', sm: '0.875rem' },
                          color: '#666',
                          maxHeight: { xs: '80px', sm: '100px', md: '120px' },
                          overflow: 'auto',
                          // Fix for iPad scrolling
                          WebkitOverflowScrolling: 'touch',
                          msOverflowStyle: 'scrollbar',
                          // Prevent horizontal scrollbar
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          maxWidth: '100%'
                        }}>
                          {reportEmailData.message || 'No message content'}
                        </Box>
                        <Typography variant="body2" color="text.secondary" mt={1}>
                          <strong>Attachment:</strong> 📎 {reportEmailData.reportData?.name || 'student'}-report.pdf
                        </Typography>
                      </Box>
                    </Box>

                    {/* Action Buttons - Always Visible */}
                    <Box 
                      display="flex" 
                      gap={{ xs: 1, sm: 2 }} 
                      flexDirection={{ xs: 'column', sm: 'row' }}
                      sx={{
                        position: 'sticky',
                        bottom: 0,
                        bgcolor: 'background.paper',
                        pt: 2,
                        borderTop: '1px solid #e0e0e0',
                        mt: 'auto'
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={() => setReportEmailPreviewOpen(false)}
                        fullWidth
                        size={isMobile ? "small" : "medium"}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handleSendReportEmailFromPreview}
                        disabled={sendingReportEmail || !reportEmailData.to || !reportEmailData.subject || !reportEmailData.message}
                        fullWidth
                        startIcon={<EmailIcon />}
                        size={isMobile ? "small" : "medium"}
                      >
                        {sendingReportEmail ? "Sending..." : "Send Report Email"}
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            </Modal>

            {/* Download Report Modal */}
            <Modal
              open={downloadModalOpen}
              onClose={() => setDownloadModalOpen(false)}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: { xs: "95%", sm: "90%", md: "50%" },
                  height: { xs: "80vh", sm: "85vh", md: "100%" },
                  bgcolor: "#ffff",
                  boxShadow: 24,
                  borderRadius: 2,
                  p: 1,
                  outline: "none",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Header with Email Button */}
                <Box sx={{ 
                  display: "flex", 
                  justifyContent: "space-between", 
                  alignItems: "center",
                  mb: 1,
                  px: 1,
                  pt: 1
                }}>
                  <Typography variant="h6" textAlign="left">
                    Report
                  </Typography>
                  
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Button
                      variant="contained"
                      startIcon={<EmailIcon />}
                      onClick={() => handleEmailReportFromModal()}
                      sx={{
                        bgcolor: 'primary.main',
                        color: 'white',
                        '&:hover': { bgcolor: 'primary.dark' }
                      }}
                    >
                      Email Report
                    </Button>
                    
                    <IconButton
                      onClick={() => setDownloadModalOpen(false)}
                      sx={{ 
                        bgcolor: 'grey.100',
                        '&:hover': { bgcolor: 'grey.200' }
                      }}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Box>
                </Box>

                {/* PDF Viewer */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <ReportPagePDF allReport={allReport} />
                </Box>
              </Box>
            </Modal>
          </>
        </Box>
      </Box>
      <Footer />
      
      {/* Add User Modal */}
      <AddUserModal
        open={addUserModalOpen}
        onClose={handleAddUserClose}
        onSubmit={handleAddUserSubmit}
      />
      
      {openConfirmationDialog && (
        <AlertDialogSlide
          open={openConfirmationDialog}
          setOpen={setOpenConfirmationDialog}
          lable="Deactivate Candidate"
          message="Are you sure you want to deactivate this candidate? This action will set the user to inactive status."
          handleDelte={() =>
            handleDelte(
              userData.userId,
              selectedIds,
              setRefetch,
              setOpenConfirmationDialog
            )
          }
        />
      )}
    </>
  );
};

export default Dashboard;
